export const formFields = {
  durationMonths: 'durationMonths',
  student: 'student',
  heavyUse: 'heavyUse',
  basketAddon: 'basketAddon',
} as const;

export const formValues = {
  [formFields.durationMonths]: {
    1: '1',
    6: '6',
    12: '12',
  },
  [formFields.student]: {
    yes: 'yes',
    no: 'no',
  },
  [formFields.heavyUse]: {
    yes: 'yes',
    no: 'no',
    '': '',
  },
  [formFields.basketAddon]: false,
} as const;

export interface FormValues {
  durationMonths: (typeof formValues.durationMonths)[keyof typeof formValues.durationMonths];
  student: (typeof formValues.student)[keyof typeof formValues.student];
  heavyUse: (typeof formValues.heavyUse)[keyof typeof formValues.heavyUse];
  basketAddon: boolean;
}
